"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAME = exports.rule = void 0;
const GenericValidator_1 = require("./GenericValidator");
/**
 * {
 *   type: 'required',
 * }
 */
exports.rule = (config) => new GenericValidator_1.GenericValidator(config, (value) => {
    return value !== null && value !== undefined && value !== '';
}, "Value '%s' is required", true);
exports.NAME = 'REQUIRED';
//# sourceMappingURL=RequiredRule.js.map